import React, { useState } from 'react';
import { isShippable, dispatchExternalEvent } from '@sbt-web/utils';
import { sendEventToGTM } from '@sbt-web/tracking';
import { getContactInfo } from '@sbt-web/network/client';
import { Phone, Palette, Button } from '@sbt-web/ui';
import { useViewport } from '@sbt-web/hooks';
import { phoneContactTrackingEvent } from './tracking.js';
import classes from './index.module.scss.js';

const PhoneContact = ({ apiBase, ad, search, pulseInstance, pageTypeForTracking, houstonTrackConversion, }) => {
    const { isMobile } = useViewport();
    const [phoneNumber, setPhoneNumber] = useState();
    const [showNumber, setShowNumber] = useState(false);
    const trackClick = () => {
        if (houstonTrackConversion) {
            houstonTrackConversion('phone_number_viewed');
        }
        dispatchExternalEvent(isMobile ? 'subito:PhoneCall' : 'subito:ShowPhoneContact', {
            urn: ad.urn,
            search,
        });
        if (pulseInstance) {
            phoneContactTrackingEvent({
                item: ad,
                search,
                pulseInstance,
                type: isMobile ? 'Call' : 'Show',
                pageID: pageTypeForTracking,
            });
        }
        sendEventToGTM(isMobile ? 'reply-call-phone' : 'shownumber');
    };
    const callOrShowNumber = (phoneNumber) => {
        if (isMobile) {
            window.open(`tel:${phoneNumber}`, '_self');
        }
        else {
            setShowNumber(true);
        }
        trackClick();
    };
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const getPhoneNumber = async () => {
            try {
                const phoneNumberResponse = await getContactInfo(apiBase, ad.urn);
                setPhoneNumber(phoneNumberResponse.body.phoneNumber);
                callOrShowNumber(phoneNumberResponse.body.phoneNumber);
            }
            catch (e) {
                console.error(e);
            }
        };
        if (!phoneNumber)
            getPhoneNumber();
        else
            callOrShowNumber(phoneNumber);
    };
    const buttonLabel = isMobile ? 'Chiama' : 'Mostra numero di telefono';
    const useIconButton = isMobile || isShippable(ad);
    if (showNumber) {
        return (React.createElement("p", { className: classes.phoneNumber },
            React.createElement(Phone, { fillColor: Palette.NeutralGrey2 }),
            React.createElement("span", { className: "body-text small semibold" }, phoneNumber)));
    }
    else if (useIconButton) {
        return (React.createElement(Button, { classes: [classes.iconButton], design: "outline", size: isMobile ? 'small' : 'medium', onClick: handleClick, "aria-label": buttonLabel, icon: React.createElement(Phone, null) }));
    }
    else {
        return (React.createElement(Button, { design: "text", size: "medium", onClick: handleClick, "aria-label": buttonLabel, icon: React.createElement(Phone, null), slim: true }, isMobile ? 'Chiama' : 'Mostra numero'));
    }
};

export { PhoneContact };
//# sourceMappingURL=index.js.map
